module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-solid-900.woff?686e245a4f1a9894d10a576655e932dd";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free/webfonts/fa-solid-900.woff
// module id = VOO1
// module chunks = 29